module.exports = __webpack_public_path__ + "static/img/pete_pictgrid38_1020x852.3d9d2de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pete_pictgrid38_1020x852.jpg
// module id = 47xC
// module chunks = 0